import React, { useEffect, useState } from 'react';
import styles from '../../formStyles.module.css';
import FormItem from '@/components/common/FormItem';

import { useTranslations } from 'next-intl';
import MainIcons from '@/icons/main';
import BadgeList from '@/components/general/BadgeList';

export default function ContactInfoForm({ info, setInfo }) {
  const tCommon = useTranslations('common');
  // const [active, setActive] = useState();
  const contactTopics = [
    { id: 1, title: 'پشتیبانی' },
    { id: 2, title: 'فروش و همکاری' },
    { id: 3, title: 'گزارش مشکل' },
    { id: 4, title: 'سایر موارد' },
  ];
  let formarray = [
    {
      id: 1,
      type: 'input',
      placeholder: 'نام و نام خانوادگی',
      title: 'نام و نام خانوادگی',
      error: info?.messages?.name,
      // extraInfo: ' * ',
      // styleColor: `starColor`,
      showError: info?.error?.name,
      value: info?.name,
      key: 'name',
      // wrapper: `darkInput`,
      wrapper: `lightInput`,

      // prefix: <MainIcons.userIcon />,
    },
    {
      id: 2,
      type: 'input',
      placeholder: tCommon('email'),
      title: tCommon('email'),
      error: info?.messages?.email,
      value: info?.email,
      showError: info?.error?.email,
      error: info?.messages?.email,
      key: 'email',
      wrapper: `lightInput`,
      // prefix: <MainIcons.emailIcon />,
      // disabled: true,
      // extraWrapperClass: styles.fullInput,
    },
    {
      id: 5,
      type: 'textarea',
      placeholder: 'پیام خود را بنویسید…',
      title: 'متن پیام',
      error: info?.messages?.content,
      // extraInfo: ' * ',
      // styleColor: `starColor`,
      showError: info?.error?.content,
      value: info?.content,
      key: 'content',
      // wrapper: `darkInput`,
      wrapper: `lightInput ${styles.textareaContact}`,
      extraWrapperClass: `${styles.fullInput}`,
      // prefix: <MainIcons.userIcon />,
    },
  ];

  const [formList, setFormList] = useState(formarray);

  useEffect(() => {
    if (info) {
      setFormList(formarray);
    }
  }, [info]);

  const onChange = (value, key) => {
    let valueIs = {
      ...info,
      [key]: value,
      error: {
        ...info?.error,
        [key]: false,
      },
    };

    setInfo(valueIs);
  };

  console.log('info==', info);

  return (
    <div className={`${styles.formContainer}`}>
      {formList?.slice(0, 2)?.map((item, index) => (
        <FormItem
          type={item.type}
          inputType={item.inputType}
          key={index}
          item={item}
          index={index}
          onChange={onChange}
          value={info?.[`${item?.key}`]}
        ></FormItem>
      ))}
      <BadgeList
        className={`${styles.fullInput}`}
        list={contactTopics}
        active={info?.subject?.id}
        activeKey={'id'}
        onClick={(id) => {
          onChange(id, 'subject');
        }}
        title="موضوع پیام"
        error={info?.messages?.subject}
        showError={info?.error?.subject}
      />
      {formList?.slice(2)?.map((item, index) => (
        <FormItem
          type={item.type}
          inputType={item.inputType}
          key={index}
          item={item}
          index={index}
          onChange={onChange}
          value={info?.[`${item?.key}`]}
        ></FormItem>
      ))}
    </div>
  );
}
